import { Injectable } from '@angular/core';
import { BusinessCentralService } from '../services/businessCentral/businessCentral.service';

@Injectable()
export class BusinessCentralModelRepository {
  constructor(private businessCentralService: BusinessCentralService) {}

  public getBCClientInformation(id: string) {
    return this.businessCentralService.getToolModelById(id);
  }
  public getBCClientData() {
    return this.businessCentralService.getClientBCData();
  }
  public getBCClientPdf(id: string) {
    return this.businessCentralService.getClientPaymentPDF(id);
  }
  public getBCClientTaxValue() {
    return this.businessCentralService.getClientBCTaxValue();
  }
}
